// @ts-nocheck

import { useContext } from 'react';

import PictureInPictureContext from '../contexts/PictureInPictureContext';

/**
 * Custom hook which returns all the necessary values for the picture in picture to work properly
 *
 * @return {Object} all the values from the picture in picture context
 */
const usePictureInPicture = () => useContext(PictureInPictureContext);

export default usePictureInPicture;
